<template>
  <div class="formSectionCompound">
    <div class="jq_gridcontentarea">
      <input-field
        id="visitAddress-postcode"
        :$v="$v.address.postcode"
        :value="address.postcode"
        :required="required"
        :maxlength="6"
        :normalization-filter="filters.upperCase"
        :disabled="disableFields"
        :label="getPostcodeLabel()"
        name="visitAddress[postcode]"
        @input="(v) => setCompanyAddressProperty('postcode', v)"
      />
    </div>
    <div class="jq_gridcontentarea">
      <input-field
        id="visitAddress-houseNumber"
        :$v="$v.address.houseNumber"
        :value="address.houseNumber"
        :required="required"
        :maxlength="5"
        :normalization-filter="filters.digits"
        :custom-container-classes="['small-7', 'wm-field', 'columns']"
        :disabled="disableFields"
        :label="getHouseNumberLabel()"
        name="visitAddress[houseNumber]"
        @input="(v) => setCompanyAddressProperty('houseNumber', v)"
      />
      <input-field
        id="visitAddress-houseNumberExtension"
        :$v="$v.address.houseNumberExtension"
        :value="address.houseNumberExtension"
        :required="required"
        :maxlength="10"
        :custom-container-classes="['small-5', 'end', 'wm-field', 'columns']"
        :disabled="disableFields"
        name="visitAddress[houseNumberExtension]"
        label="&#160;"
        @input="(v) => setCompanyAddressProperty('houseNumberExtension', v)"
      />
    </div>
    <div class="jq_gridcontentarea">
      <input-field
        id="visitAddress-street"
        :$v="$v.address.street"
        :value="address.street"
        :required="required"
        :maxlength="50"
        :normalization-filter="filters.capitalize"
        :disabled="disableFields"
        :label="getStreetLabel()"
        name="visitAddress[street]"
        @input="(v) => setCompanyAddressProperty('street', v)"
      />
    </div>
    <div class="jq_gridcontentarea">
      <input-field
        id="visitAddress-city"
        :$v="$v.address.city"
        :value="address.city"
        :required="required"
        :maxlength="50"
        :normalization-filter="filters.capitalize"
        :disabled="disableFields"
        :label="getCityLabel()"
        name="visitAddress[city]"
        @input="(v) => setCompanyAddressProperty('city', v)"
      />
    </div>
    <div class="jq_gridcontentarea">
      <select-field
        id="visitAddress-countryCode"
        :$v="$v.address.countryCode"
        :value="address.countryCode"
        :options="countryCodeOptions"
        :required="required"
        :disabled="disableFields"
        :label="getCountryLabel()"
        name="visitAddress[countryCode]"
        @change="(v) => setCompanyAddressProperty('countryCode', v)"
      />
    </div>
  </div>
</template>

<script>
import BaseAddressSubForm from './BaseAddressSubForm'
import { required, maxLength, integer } from 'vuelidate/lib/validators'
import {cityName, postcode, streetName} from '../../validators'

export default {
  name: 'VisitAddressSubForm',
  extends: BaseAddressSubForm,
  validations () {
    const validationConfig = {
      address: {
        city: {
          maxLength: maxLength(50),
          cityName
        },
        houseNumber: {
          integer,
          maxLength: maxLength(5)
        },
        houseNumberExtension: {
          maxLength: maxLength(10)
        },
        street: {
          maxLength: maxLength(50),
          streetName
        },
        postcode: {
          maxLength: maxLength(6),
          postcode: postcode(this.address.countryCode)
        },
        ...this.baseAddressValidationConfig
      }
    }
    if (this.required) {
      validationConfig.address.postcode['required'] = required
      validationConfig.address.houseNumber['required'] = required
      validationConfig.address.street['required'] = required
      validationConfig.address.city['required'] = required
    } else {
      delete validationConfig.address.postcode.required
      delete validationConfig.address.houseNumber.required
      delete validationConfig.address.street.required
      delete validationConfig.address.city.required
    }

    return validationConfig
  },
  methods: {
    getPostcodeLabel () {
      return 'Postcode' + (this.required ? ' *' : '')
    },
    getHouseNumberLabel () {
      return 'Huisnummer en toevoeging' + (this.required ? ' *' : '')
    },
    getStreetLabel () {
      return 'Straat' + (this.required ? ' *' : '')
    },
    getCityLabel () {
      return 'Plaats' + (this.required ? ' *' : '')
    },
    getCountryLabel () {
      return 'Land' + (this.required ? ' *' : '')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/forms/VisitAddressSubForm.vue